import React from 'react';
import { Alert } from 'react-bootstrap';
import PageLayout from '../../layouts/PageLayout';
import { useBranch } from '../../hooks';
import WeekClosePanel from '../../components/admin-shift-review/WeekClosePanel';

export default function TltPenaltyReviewPage() {
  const { selectedBranch } = useBranch();
  return (
    <PageLayout title="Chốt tuần: thưởng bảng xếp hạng + trừ TLT">
      <Alert
        variant="light"
        className="border small"
      >
        Hệ thống <b>không còn tự chốt</b> bảng xếp hạng ca và <b>không còn tự trừ</b> TLT. Duyệt ca xong, xem bên dưới
        rồi bấm <b>Chốt tuần</b>: chốt bảng xếp hạng + cộng thưởng top, trừ TLT những người được tích. Nút này cũng có ở
        màn Quản lý ca làm việc (tab Lịch và tab Xếp hạng đóng góp ca). Bấm lại không cộng/trừ chồng.
      </Alert>
      {selectedBranch?.id && <WeekClosePanel branchId={selectedBranch.id} />}
    </PageLayout>
  );
}
